import { SxProps, Theme } from '@mui/material'

const BRAND_BLUE = '#1B4AA0'

export const positionResultsStyles = {
  // ── Section label ─────────────────────────────────────────────────────────

  sectionLabel: {
    whiteSpace: 'nowrap',
    fontSize: '1rem',
    textAlign: 'left',
    width: '100%',
    pb: '4px'
  } as SxProps<Theme>,

  // ── Context card ──────────────────────────────────────────────────────────

  contextCard: {
    bgcolor: 'background.paper',
    border: '0.5px solid',
    borderColor: 'divider',
    borderRadius: 2,
    p: 1
  } as SxProps<Theme>,

  backChip: {
    borderRadius: '12px',
    height: '50px',
    minWidth: '110px',
    paddingLeft: '10px',
    paddingRight: '14px',
    zIndex: 1,
    backgroundColor: 'transparent',
    border: '1px solid #E0E0E0',
    boxShadow: 'none',
    fontSize: '14px',
    fontWeight: 500,
    color: '#666',
    gap: '2px',
    textTransform: 'none'
  } as SxProps<Theme>,

  infoChip: {
    fontSize: '0.8125rem',
    fontWeight: 500
  } as SxProps<Theme>,

  warningAlert: {
    mt: 1.5,
    fontSize: 13,
    borderRadius: 1
  } as SxProps<Theme>,

  // ── Empty state ───────────────────────────────────────────────────────────

  emptyState: {
    border: '1px dashed',
    borderColor: 'divider',
    borderRadius: 2,
    py: 4,
    textAlign: 'center'
  } as SxProps<Theme>,

  emptyIcon: {
    fontSize: 40,
    color: 'text.disabled',
    mb: 1
  } as SxProps<Theme>,

  // ── Metric cards ──────────────────────────────────────────────────────────

  metricCard: {
    flex: 1,
    bgcolor: 'background.paper',
    border: '0.5px solid',
    borderColor: 'divider',
    borderRadius: 2,
    p: 1.5,
    textAlign: 'center'
  } as SxProps<Theme>,

  metricLabel: {
    fontSize: 11,
    color: 'text.secondary',
    textTransform: 'uppercase',
    fontWeight: 500
  } as SxProps<Theme>,

  metricValue: {
    fontSize: 20,
    fontWeight: 500,
    lineHeight: 1.2
  } as SxProps<Theme>
}

export const skuCardStyles = {
  // ── Card container ────────────────────────────────────────────────────────

  card: {
    bgcolor: 'background.paper',
    border: '0.5px solid',
    borderColor: 'divider',
    borderRadius: 2,
    overflow: 'hidden'
  } as SxProps<Theme>,

  // ── Header ────────────────────────────────────────────────────────────────

  skuCode: {
    fontWeight: 600,
    fontSize: 14,
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: 1,
    px: 1,
    py: 0.25
  } as SxProps<Theme>,

  fefoChip: {
    height: 20,
    fontSize: 11,
    bgcolor: '#EAF4EA',
    color: '#2E7D32',
    fontWeight: 500,
    '& .MuiChip-label': { px: 1 }
  } as SxProps<Theme>,

  fefoChipDot: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    bgcolor: '#2E7D32',
    ml: '6px !important'
  } as SxProps<Theme>,

  brandChip: {
    height: 22,
    fontSize: 12,
    borderRadius: 1,
    alignSelf: 'flex-start',
    borderColor: 'divider',
    fontWeight: 500
  } as SxProps<Theme>,

  quantityLabel: {
    fontSize: 11,
    color: 'text.secondary',
    textTransform: 'uppercase'
  } as SxProps<Theme>,

  quantityValue: {
    fontSize: 22,
    fontWeight: 600,
    lineHeight: 1.1
  } as SxProps<Theme>,

  // ── FEFO toggle ───────────────────────────────────────────────────────────

  fefoToggle: {
    bgcolor: '#E8EEF8',
    py: 1,
    textAlign: 'center',
    cursor: 'pointer',
    '&:hover': { bgcolor: '#dde6f5' }
  } as SxProps<Theme>,

  fefoToggleLabel: {
    fontSize: 13,
    color: BRAND_BLUE,
    fontWeight: 500
  } as SxProps<Theme>,

  // ── Batch detail ──────────────────────────────────────────────────────────

  batchHeader: {
    pt: 1.5,
    pb: 0.5
  } as SxProps<Theme>,

  batchHeaderText: {
    fontSize: 11,
    fontWeight: 500,
    color: 'text.secondary',
    textTransform: 'uppercase'
  } as SxProps<Theme>,

  batchRow: (expired: boolean) =>
    ({
      px: 1,
      py: 0.75,
      borderRadius: 1,
      bgcolor: expired ? '#FFF0F0' : '#F0FFF0'
    }) as SxProps<Theme>,

  batchText: (expired: boolean, align?: 'center' | 'right') =>
    ({
      fontSize: 12,
      fontWeight: align === 'right' ? 600 : 500,
      color: expired ? '#C62828' : '#2E7D32',
      flex: 1,
      ...(align && { textAlign: align })
    }) as SxProps<Theme>
}
